'use client';

import { getUserInfo } from '@/services/getUserInfo';
import { UserType } from '@/types/data';
import { useRouter } from 'next/navigation';
// Tạo Context
import { createContext, useContext, useEffect, useState } from 'react';

interface AuthContextType {
  user: UserType | null;
  isAuthenticated: boolean;
  loading: boolean;
  role: string;
  logout: () => void;
}

const AuthContext = createContext<AuthContextType>({
  user: null,
  isAuthenticated: false,
  loading: true,
  role: '',
  logout: () => {},
});

// Tạo Provider
import { ReactNode } from 'react';
import { cookieName } from './constants';
import { deleteCookie, getCookie } from '@/utils/helper';

export const AuthProvider = ({ children }: { children: ReactNode }) => {
  const [user, setUser] = useState<UserType | null>(null);
  const [role, setRole] = useState<string>('');
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const router = useRouter();

  const logout = () => {
    deleteCookie(cookieName);
    // Remove Cookie
    document.cookie = 'token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    document.cookie = 'role=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    setUser(null);
    setIsAuthenticated(false);
    router.push('/auth/sign-in');
  };

  const checkAuth = async () => {
    // const getCookie = (name: string) => {
    //   const value = `; ${document.cookie}`;
    //   const parts = value.split(`; ${name}=`);
    //   if (parts.length === 2) return parts.pop()?.split(';').shift();
    // };

    const token = getCookie(cookieName);

    if (!token) {
      setLoading(false);
      return;
    }

    try {
      const res = await getUserInfo();
      setUser(res?.data);
      setRole(res?.data?.role);

      setIsAuthenticated(true);
    } catch (error) {
      // Nếu lỗi 401 thì logout
      if (
        error instanceof Error &&
        error.message === 'Phiên đăng nhập hết hạn'
      ) {
        logout();
      }
    } finally {
      setLoading(false);
    }
  };

  // Khi component mount, kiểm tra trạng thái xác thực
  useEffect(() => {
    checkAuth();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <AuthContext.Provider
      value={{ user, role, isAuthenticated, loading, logout }}
    >
      {children}
    </AuthContext.Provider>
  );
};

// Custom hook để sử dụng context
export function useAuth() {
  return useContext(AuthContext);
}
